export interface GeoIPData {
  ip?: string;
  network?: string;
  version?: string;
  city?: string;
  region?: string;
  region_code?: string;
  country?: string;
  country_name?: string;
  country_code?: string;
  country_code_iso3?: string;
  country_capital?: string;
  country_tld?: string;
  continent_code?: string;
  in_eu?: boolean;
  postal?: string;
  latitude?: number;
  longitude?: number;
  timezone?: string;
  utc_offset?: string;
  country_calling_code?: string;
  currency?: string;
  currency_name?: string;
  languages?: string;
  country_area?: number;
  country_population?: number;
  asn?: string;
  org?: string;
}

export async function getIpData(
  ipAddress: string,
): Promise<GeoIPData | undefined> {
  const url = `https://ipapi.co/${ipAddress}/json/`;

  try {
    const response = await fetch(url);
    // console.log(response, 'GetIpDataresponse');
    const data = await response.text();
    // console.log(data, 'json data');
    if (data.toLowerCase() === 'undefined') {
      return undefined;
    }
    return JSON.parse(data);
  } catch (error) {
    console.error('Error fetching IP data:', error);
    return undefined;
  }
}
